import { isNumber, isString } from "lodash";

export function TextToNumber(value: string|undefined): number|undefined
{      
  if (undefined === value)
    return;

  // TS can't prevent numbers from coming in!!
  if (isNumber(value))
    return value;    

  if (isString(value))
  {  
    // Strip common (non-numeric) formatting characters
    value = value.replace(/,/g, '').replace(/\$/g, '').trim();
    
    if (0 === value.length)
      return;

    // Move - sign to front of string  
    if (value.lastIndexOf("-") === value.length - 1) {
      value = (-(value.substring(0,value.length - 1))).toString();
    }
  
    const valueAsNumber = +value;
    if (isNaN(valueAsNumber))
      return;
  
    return valueAsNumber;    
  }

  throw new Error(`Unexpected type passed to TextToNumber: ${typeof(value)}`);

}
export function TextToNumberString(value: string|undefined): string|number|undefined 
{
  if (undefined === value)
    return value; 
  else if ("-" === value)
      return value; 
  else if (value.lastIndexOf(".") === value.length - 1) {
        return value;
  }

  return TextToNumber(value);

}

export function TextToDecimal(value: string|undefined): number|undefined
{      
  if (undefined === value)
    return;

  // TS can't prevent numbers from coming in!!
  if (isNumber(value))
    return value;    

  // Strip common (non-numeric) formatting characters
  if (isString(value))
  {
    value = value.replace(/\$/g, '').trim();
    
    if (0 === value.length)
      return;

    const valueAsNumber = +value;
    if (isNaN(valueAsNumber))
      return;
  
    return valueAsNumber;    
  }

  throw new Error(`Unexpected type passed to TextToDecimal: ${typeof(value)}`);

}
